var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96794 14.8C12.1967 14.8 14.6424 12.6367 15.1498 9.80615H12.3952C11.9835 11.3092 10.7055 12.4094 9.00056 12.4094C7.308 12.4094 6.01369 11.3013 5.5845 9.80615H2.8125C3.30131 12.6468 5.72625 14.8 8.96794 14.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98369 5.65538C9.76872 5.65538 10.4051 5.01898 10.4051 4.23394C10.4051 3.4489 9.76872 2.8125 8.98369 2.8125C8.19865 2.8125 7.56225 3.4489 7.56225 4.23394C7.56225 5.01898 8.19865 5.65538 8.98369 5.65538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43094 9.80618V9.77805C5.43094 7.75699 6.87881 6.10718 8.96625 6.10718C11.0543 6.10718 12.5325 7.78512 12.5359 9.80618H5.43094Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOng);
export default __webpack_public_path__ + "static/media/ong.925a38c297b9430125a219f4338f3ef5.svg";
export { ForwardRef as ReactComponent };